var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"type":"primary","title":("" + (_vm.order.customer_name||''))},on:{"click":_vm.goDetail}},[_vm._v("\n  "+_vm._s(_vm.order[_vm.field])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }